export default function RadioInputGroup({ children, onChange }) {
  return (
    <div onChange={(e) => onChange(e.target.value)} className="flex space-x-4">{children}</div>
  );
}
